const APPLE_APP_STORE_LINK =
    'https://apps.apple.com/us/app/bloomberg-professional/id407761767';
const GOOGLE_PLAY_STORE_LINK =
    'https://play.google.com/store/apps/details?id=com.bloomberg.android.anywhere';

export const getMobileLink = (): string | null => {
    if (typeof navigator === 'undefined') return null;
    const ua = navigator.userAgent;

    if (/iPhone|iPad|iPod/i.test(ua)) {
        return APPLE_APP_STORE_LINK;
    }
    if (/Android/i.test(ua)) {
        return GOOGLE_PLAY_STORE_LINK;
    }
    return null;
};
